'use strict';

var badge = require('../../../../../../../../../../_virtual/badge.cjs');

var hasRequiredBadge;

function requireBadge () {
	if (hasRequiredBadge) return badge.__exports;
	hasRequiredBadge = 1;

	var BADGE_COLORS = /*#__PURE__*/ function(BADGE_COLORS) {
	    BADGE_COLORS["success"] = "success";
	    BADGE_COLORS["system"] = "system";
	    BADGE_COLORS["danger"] = "danger";
	    BADGE_COLORS["light"] = "light";
	    return BADGE_COLORS;
	}({});

	badge.__exports.BADGE_COLORS = BADGE_COLORS;
	
	return badge.__exports;
}

exports.__require = requireBadge;
//# sourceMappingURL=badge.cjs.map
